import { HttpAuth } from '@core/services/http-auth';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import {
  ChangeEmailRequest,
  ChangePasswordRequest,
  UpdateUserRequest,
  UserResponse,
} from '@core/contracts/data-contracts';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MeService {
  private readonly url = `${environment.apiUrl}/api/users/me`;

  constructor(
    private readonly httpAuth: HttpAuth,
    private readonly http: HttpClient
  ) {}

  public getUserDetails() {
    return this.httpAuth.get<UserResponse>(`${this.url}`);
  }

  public getUserEmail(token: string) {
    return this.http.get<Partial<UserResponse>>(`${this.url}/email`, {
      params: { token },
    });
  }

  public updateEmail(msisdn: string, newEmail: string) {
    const changeRequest: ChangeEmailRequest = {
      newEmail,
    };
    return this.httpAuth.put(
      `${environment.apiUrl}/api/msisdns/${msisdn}/change-email`,
      changeRequest
    );
  }

  public updatePassword(oldPassword: string, newPassword: string) {
    const changeRequest: ChangePasswordRequest = {
      oldPassword,
      newPassword,
    };
    return this.httpAuth.put(`${this.url}/change-password`, changeRequest);
  }

  public updateUser(msisdn: string, user: UpdateUserRequest) {
    return this.httpAuth.put(`${environment.apiUrl}/api/msisdns/${msisdn}/update-customer`, user);
  }

  public activateSimcard(customerId: number) {
    return this.httpAuth.post(`${this.url}/card/activation?customerId=${customerId}`);
  }
}
